class GridViewToggle extends HTMLElement {
    constructor() {
        super();

        this.lessCardBtn = this.querySelector('[data-grid-less-card]');
        this.moreCardBtn = this.querySelector('[data-grid-more-card]');
    }

    connectedCallback() {
        this.lessCardBtn.addEventListener('click', () => this.activateLessView());
        this.moreCardBtn.addEventListener('click', () => this.activateMoreView());
    }

    getCards() {
        return document.querySelectorAll('#ProductGridContainer #product-grid .grid__item');
    }

    activateLessView() {
        const cards = this.getCards();
        cards.forEach((card) => {
            card.classList.add('grid-item-less-card');
        });
        this.lessCardBtn.classList.add('active');
        this.moreCardBtn.classList.remove('active');
    }

    activateMoreView() {
        const cards = this.getCards();
        cards.forEach((card) => {
            card.classList.remove('grid-item-less-card');
        });
        this.lessCardBtn.classList.remove('active');
        this.moreCardBtn.classList.add('active');
    }
}

customElements.define('grid-view-toggle', GridViewToggle);